import { useState } from 'react';
import { Input, Spin, Tag, Button } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import CommonLayout from '../../../layouts/Common';
import { ColumnsType } from 'antd/es/table';
import { HeaderData, NameData, SearchWrapper } from './style';
import CommonTable from '../../../components/Common/Table';
import useAdminGetClients from '../../../hooks/admin/useAdminGetClients';
import { ClientType } from '../../../types';
import { formatDate } from '../../../helpers';
import { StyledButton } from '../../../components/Common/Button/style';

const AdminClients = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [search, setSearch] = useState<string>('');
  
  const { data: clients, loading, total, perPage } = useAdminGetClients(currentPage, 15, search);

  const columns: ColumnsType<any> = [
    {
      title: <HeaderData>Name</HeaderData>,
      render: (text, record) => (
        <NameData>{record.firstName} {record.familyName}</NameData>
      ),
    },
    {
      title: <HeaderData>Email</HeaderData>,
      dataIndex: 'email',
    },
    {
      title: <HeaderData>Professional Code</HeaderData>,
      dataIndex: 'professionalCode',
      render: (text) => (
        <span>{text || '-'}</span>
      )
    },
    {
      title: <HeaderData>Type</HeaderData>,
      dataIndex: 'type',
      render: (text) => (
        <span>{text || 'Full'}</span>
      )
    },
    {
      title: <HeaderData>Created</HeaderData>,
      dataIndex: 'createdAt',
      render: (text) => (
        <>
          {formatDate(text)}
        </>
      )
    },
    {
      title: <HeaderData>Status</HeaderData>,
      dataIndex: 'accountStatus',
      render: (text) => {
        if (text === 'loading') {
          return <Tag color="blue">loading</Tag>;
        }
        return (
          <Tag color={text === 'active' ? 'green' : 'orange'}>
            {text === 'active' ? 'active' : 'email_not_validated'}
          </Tag>
        );
      },
    },
    {
      title: <HeaderData>Login as</HeaderData>,
      render: (text, record) => (
        <StyledButton 
          icon={<i className="material-icons-round">login</i>} 
          onClick={() => console.log('Login as', record.email)}
        />
      ),
    }
  ];

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };

  return (
    <CommonLayout title="Clients" width="1200px">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '-25px' }}>
          <Button type="link" onClick={() => window.history.back()}>Back</Button>
      </div>
      
      <SearchWrapper>
        <Input
          placeholder="Search by name or email..."
          prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
          value={search}
          onChange={handleSearch}
          allowClear
        />
      </SearchWrapper>

      {loading && currentPage === 1 && !clients?.length ? (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <Spin size="large" tip="Loading clients..." />
        </div>
      ) : (
        <CommonTable
          showNewModal={false}
          showNewButton={false}
          onNewData={() => {}}
          showEditModal={false}
          onEditData={() => {}}
          handleBack={() => {}}
          modalForm={<></>}
          columns={columns}
          dataSource={clients ?? []}
          page={currentPage}
          setCurrentPage={setCurrentPage}
          perPage={perPage}
          totalData={total}
          tableType="Client"
          total={`${total} clients`}
        />
      )}
    </CommonLayout>
  )
};

export default AdminClients;
